import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { ClientSearch } from '../model/client-search';
import { Observable } from 'rxjs';
import { ClientFilter } from '../model/client-filter';
import { Client, ClientEdit } from '../model/client/client-edit';

@Injectable()
export class ClientService {
  constructor(private http: HttpClient, private dataService: DataService) { }

  private readonly getClientsFromSearchEndPoint: string = '/client/getClientSearch/';
  private readonly getClientFiltersEndPoint: string = '/client/getClientFilters/';
  private readonly getClientSearchEndPoint: string = '/client/getClientSearch/';
  private readonly getClientEditEndPoint: string = '/client/getClientEdit/';
  private readonly createEndPoint: string = '/client';

  async getClientSearch( id: number ): Promise<ClientSearch> {
    const params = { id };
    return await this.dataService.get<ClientSearch>
      (this.getClientSearchEndPoint, params).toPromise();
  }

  async getClientEdit(id: number | null = null): Promise<ClientEdit> {
    const params = { id };
    return await this.dataService.get<ClientEdit>(this.getClientEditEndPoint, params).toPromise();
  }

   async getClientFilters(): Promise<ClientFilter[]> {
    const params = {  };
    return await this.dataService.get<ClientFilter[]>(this.getClientFiltersEndPoint, params).toPromise();
  }

  getClientsFromSearch(filter: string): Observable<ClientSearch[]> {

    if (!filter || filter === '') {
      return new Observable<ClientSearch[]>();
    }

    const params = {
      filter: filter
    };
    return this.dataService.get<ClientSearch[]>(this.getClientsFromSearchEndPoint, params);
  }

  async update(client: Client): Promise<number> {
    return await this.dataService.post<number>(this.createEndPoint, client).toPromise();
  }

}
